module.exports = __webpack_public_path__ + "img/markets-hsc.b94ce8cb.jpg";